import http from "../../backend/http.js";

async function getCompany(id) {
  try {
    const response = await http.get(`crm/companies/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      webSite: response.data.website,
      contacts: response.data.contacts,
      agreements: response.data.agreements,
    };
  } catch (err) {
    throw err;
  }
}

async function updateCompany(id, company) {
  try {
    const response = await http.put(`crm/companies/${id}`, company);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createCompany(company) {
  try {
    const response = await http.post("crm/companies", company);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getCompanies(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `crm/companies?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectCompany(
    page = 1,
    rowsPerPage = 9,
    search = ""
) {
  try {
    const response = await http.get(
      "crm/companies/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}


export { getCompany, updateCompany, selectCompany, getCompanies, createCompany };
